import React from 'react';
import './ResetPassword.scss';  
import row from "../../../Assets/image (58).png";
import logo from "../../../Assets/image (90).png";
import sidelogo from "../../../Assets/image (59).png";

export default function ResetPassword() {
  return (



     
        <div className="reset-form">
          <h2 className="reset-title">Re-Set Password</h2>
<p>Create your new Password and confirm it.</p>
          <div className="reset-input-group">
           
            <input type="text" placeholder="New Password" />
          </div>

          <div className="reset-input-group">
       
            <input type="password" placeholder="Confirm Password" />
          </div>

          <button className="reset-button">Save change</button>

          
        </div>
     
  );
}
